const revenueByRepair = (revenues: any) => {
  let data: any = [];
  const result = revenues.filter((revenue: any) => revenue._id === "REPAIR")[0];
  const repair = result === undefined ? [] : result;

  repair?.list?.forEach((repr: any) => {
    repr?.list?.forEach((item: any) => {
      data.push(item);
    });
  });

  return { repair, data };
};

export default revenueByRepair;
